module.exports = __webpack_public_path__ + "img/gh_95f2062610c3_860.ff327974.jpeg";